import { cloneState } from './state';
import type { GameState } from './types';

/** Max snapshots retained — caps localStorage footprint on long games. */
export const HISTORY_LIMIT = 200;

/**
 * Append a snapshot of `prev` to `history`, returning a new history array.
 * Caller is responsible for only pushing on state-changing transitions.
 */
export function pushHistory(history: GameState[], prev: GameState): GameState[] {
  const next = history.length >= HISTORY_LIMIT ? history.slice(1) : history.slice();
  next.push(cloneState(prev));
  return next;
}

/** Pop the most recent snapshot; returns null if history is empty. */
export function popHistory(
  history: GameState[],
): { state: GameState; history: GameState[] } | null {
  if (history.length === 0) return null;
  const next = history.slice(0, -1);
  const state = cloneState(history[history.length - 1]);
  return { state, history: next };
}

export function canUndo(history: GameState[]): boolean {
  return history.length > 0;
}
